import { render } from "./ToggleRemindersBtn.vue?vue&type=template&id=6c381a74&ts=true"
import script from "./ToggleRemindersBtn.vue?vue&type=script&lang=ts"
export * from "./ToggleRemindersBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__